import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Careerveteran() {
  return (
    <section className="career_veteran p-100 text_veteran">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/veteran-app/career_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={686}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>
              From Career Advancement To Building Local Veteran Communities
            </h2>
            <p>
              The Veteran App connects US veterans with all types of facilities
              that can help them re-build their lives after coming back from the
              frontlines. The app has been designed to ensure that every Veteran
              has a specialized database and profile. This data is then used for
              matching opportunities that best suit the Veteran’s interests and
              requirements.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Careerveteran;
